<template>
  <div class="persenPage" v-if="showHide">
    <el-dialog
      :close-on-click-modal="false"
      title="导出数据"
      :visible.sync="showHide"
      @close="cancel"
      append-to-body
      width="780px"
      center
      class="add-dialog"
    >
      <div class="select_export">
        <template v-for="(item, index) in exportDataList">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            class="select_export_item"
            plain
            v-if="item.code != 4"
            :key="index"
            @click="exportDownload(item)"
          >
            {{ item.name }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            class="select_export_item"
            plain
            v-if="item.code == 4 && isFundExport"
            :key="index"
            @click="exportDownload(item)"
          >
            {{ item.name }}
          </el-button>
        </template>

      </div>
    </el-dialog>
  </div>
</template>
<!-- 
   组件引用 <ExportData ref="exportData" @exportDownload="exportDownload"  />
   调用组件 this.$refs.exportData.showModel();
   
 *
 -->
<script>
import * as validate from "@/util/validate";
export default {
  name: "exportData",
  data() {
    return {
      showHide: false,
      exportDataList: [
        { name: "当前页(已筛选)", code: 1 },
        { name: "所有数据(已筛选)", code: 2 },
        { name: "所有数据(无筛选)", code: 3 },
        { name: "原始数据", code: 4 },
      ],
    };
  },
  watch: {},
  props: {
    isFundExport: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  methods: {
    showModel() {
      this.showHide = true;
    },
    exportDownload(value) {
      this.$emit("exportDownload", value);
      this.$message({
          type: "success",
          message: "正在下载中....",
      });
      this.showHide = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.select_export {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .select_export_item {
    width: 140px;
    margin-right: 22px;
  }
}
// /deep/ .el-button {
//    margin-left:0;
// }
</style>
